import { render } from "./LayoutProduction.vue?vue&type=template&id=e4d20b4c&ts=true"
import script from "./LayoutProduction.vue?vue&type=script&lang=ts"
export * from "./LayoutProduction.vue?vue&type=script&lang=ts"

import "./LayoutProduction.vue?vue&type=style&index=0&id=e4d20b4c&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__